/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from "react-i18next";
import { get, map, toString, isEmpty } from "lodash";
import {
  IconButton,
  Pagination,
  Stack,
  Chip,
  Menu,
  MenuItem,
  Link as LinkMui,
  Button,
  Dialog,
  Fade,
  Box,
  Typography,
  CircularProgress
} from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PhoneIcon from '@mui/icons-material/Phone';
import { Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import ReplayIcon from '@mui/icons-material/Replay';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import AddIcon from '@mui/icons-material/Add';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import { Download } from '@mui/icons-material';

import Table from "../../../components/form/Table";
import Notification from "../../../components/form/Notification";
import Alert from "../../../components/form/Alert";
import Question from "../../../components/form/Question";
import TariffModal from "./TariffModal";
import { useCanView } from "../../../config/hook/UserPermissions";

import { getClientId } from "../../../store/masters/thunk/client/getId";
import { deleteService } from "../../../store/masters/thunk/services/delete";
import { postImportServiceClient } from "../../../store/masters/thunk/importServiceClient/post";

const Tarrif = ({ setBtns }) => {
  const [__] = useTranslation("tarrif");
  const dispatch = useDispatch();
  const { id } = useParams();
  const PageSize = 5;
  const canView = useCanView();

  const [anchorEl, setAnchorEl] = React.useState(null);
  const openMenu = Boolean(anchorEl);
  const [selected, setSelected] = useState({})
  const [showNoti, setShowNoti] = useState({ open: false, msg: "", variant: "error", action: "post" })
  const [alert, setAlert] = useState({ open: false, title: "", subtitle: "", type: "" });
  const [openModal, setOpenModal] = useState(false);
  const [openQuestion, setOpenQuestion] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const inputFileRef = useRef(null);

  const services = useSelector(state => state.masters.service);
  const current = useSelector((state) => state.masters.client.detail);
  const delet = useSelector(state => state.masters.service.delete);
  const put = useSelector(state => state.masters.service.put);
  const post = useSelector(state => state.masters.service.post);
  const importService = useSelector(state => state.masters.importServiceClient.post);
  const getData = ({ page, filter }) => {
    dispatch(getClientId({ id }));
  };

  const reload = () => getData({ page: 1 })

  useEffect(() => {
    setAnchorEl(false)
    getData({ page: 1 })
  }, [dispatch])

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
    event.target.value = "";
  };

  useEffect(() => {
    if (selectedFile) {
      const formData = new FormData();
      formData.append("CustomerId", id);
      formData.append("File", selectedFile);
      dispatch(postImportServiceClient(formData));
      setSelectedFile(null);
    }
  }, [selectedFile]);

  useEffect(() => {
    if (get(importService, "isSuccess", false)) { reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "post" }) }
    if (get(importService, "isReject", false)) { setError(get(importService, "error", {}), "post") }
  }, [importService])

  useEffect(() => {
    setBtns(
      <Stack className='mr-4' direction="row" spacing={1} justifyContent="flex-end">
        <a href={`/PlantillaServicios.csv`} download>
          <Button
            variant="contained"
            color="warning"
            startIcon={<Download />}
          >
            Descargar Plantilla
          </Button>
        </a>
        <Button
          variant="contained"
          sx={{ backgroundColor: '#00BFFF', color: 'white' }}
          startIcon={<ImportExportIcon />}
          onClick={() => {
            if (canView("MAESTROS/CLIENTES/TARIFARIOS/IMPORTAR", "add")) {
              inputFileRef.current.click()
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para importar tarifarios.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
          }}
        >
          Importar
        </Button>
        <input
          type="file"
          accept=".csv"
          ref={inputFileRef}
          hidden
          onChange={handleFileUpload}
        />
        <Button className='w-[100px] min-w-[100px]' variant="contained" color="secondary" onClick={() => {
                    if (canView("MAESTROS/CLIENTES/TARIFARIOS", "add")) {
                      setOpenModal(true)
                    } else {
                      setAlert({
                        open: true,
                        title: "Permiso Denegado.",
                        subtitle: (<ul> • No tienes permiso para agregar nuevos tarifarios.</ul>),
                        type: "error",
                        btn: __(`${module}.actions.close`),
                        func: closeAlert
                      })
                    }
          }} startIcon={<AddIcon/>}>{__(`toolbar.btn`)}</Button>
        <IconButton title={__(`toolbar.reload`)} onClick={reload}><ReplayIcon sx={{ transform: "scaleX(-1) rotate(-45deg)" }} /></IconButton>
      </Stack>
    )
  }, [])

  const handleOpenMenu = (row) => (event) => {
    setSelected(row)
    setAnchorEl(event.currentTarget);
  };

  const handleEditService = (row) => {
    setSelected(row);  
    setOpenModal(true);  
  };

  const handleCloseMenu = () => {
    setSelected({})
    setAnchorEl(null);
  };

  const onDelete = () => {
    dispatch(deleteService(Number(get(selected, "id"))))
    setSelected({})
  }
  const handleDelete = (row) => () => {
    setAnchorEl(null)
    setOpenQuestion(true)
    setSelected(row)
  }

  const closeAlert = () => {
    setAlert({ open: false, title: "", subtitle: "", type: "", btn: "" })
  }

  const setError = (err, action) => {
    if (!isEmpty(err) && !!get(err, "Message", "")) {
      setAlert({
        open: true,
        title: get(err, "Message", ""),
        subtitle: (<ul>{map(get(err, "ValidationError", []), (services) => <li>{`• ${services}`}</li>)}</ul>),
        type: "error",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    } else {
      setAlert({
        open: true,
        type: "default",
        btn: __(`${module}.actions.close`),
        func: closeAlert
      })
    }
    handleCloseMenu()
  }

  useEffect(() => {
    if (get(delet, "isSuccess", false)) { setOpenQuestion(false); reload(); setShowNoti({ open: true, msg: "", variant: "success", action: "delet" }) }
    if (get(delet, "isReject", false)) { setError(get(delet, "error", {}), "delet") }
    if (get(post, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "post" })}
    if (get(post, "isReject", false)) { setError(get(post, "error", {}), "post") }
    if (get(put, "isSuccess", false)) { setShowNoti({ open: true, msg: "", variant: "success", action: "put" })}
    if (get(put, "isReject", false)) { setError(get(put, "error", {}), "put") }
  }, [post, put, delet])

  const servicesAll = get(current, "data.services", []);
 
  const headTable = [
    {
      key: "status",
      label: __(`table.cols.isAutomatic`),
      align: "center"
    },
    {
      key: "id",
      label: __(`table.cols.id`),
      align: "center"
    },
    {
      key: "codInvoices",
      label: __(`table.cols.COD_FACTURA`),
      align: "center"
    },
    {
      key: "description",
      label: __(`table.cols.description`),
      align: "center"
    },
    {
      key: "routeType",
      label: __(`table.cols.routeType`),
      align: "center",
    },
    {
      key: "division",
      label: __(`table.cols.division`),
      align: "center"
    },
    {
      key: "transportType",
      label: __(`table.cols.transportType`),
      align: "center"
    },
    {
      key: "municipality",
      label: __(`table.cols.startCity`),
      align: "center"
    },
    {
      key: "municipalityEnd",
      label: __(`table.cols.endCity`),
      align: "center"
    },
    {
      key: "price",
      label: __(`table.cols.price`),
      align: "center",
      sx: {
        width: 150,
        minWidth: 150
      }
    },
    {
      key: "options",
      label: __(`table.cols.options`),
      align: "center",
      sx: { position: "sticky", right: 0, pr: 1, background: "linear-gradient(90deg, hsla(0, 0%, 100%, 1) 0%, hsla(0, 0%, 87%, 1) 8px, hsla(0, 0%, 100%, 1) 8px, hsla(0, 0%, 100%, 1) 100%)" }
    },
  ]



  const dataTable = map(servicesAll, (row, i) => ({
    ...row,
    status: <Chip label={get(row, "isAutomatic") === true ? __("Automático") : __("No Automático")} color={get(row, "isAutomatic") === true ? "success" : "error"}/>,
    id: (<Button onClick={() => handleEditService(row)}>{get(row, "id")}</Button>),
    price: `$ ${get(row, "price", 0)?.toFixed(2)}`,
    options: <IconButton aria-label="more" size="small" onClick={handleOpenMenu(row)}><MoreVertIcon fontSize="inherit" /></IconButton>
  }))
  const onChangePagination = (e, page) => getData({ page })

  return (
    <div className='mt-4'>
      <Table headTable={headTable}
        dataTable={dataTable}
        __={__}
        sizeFilters={125}
        loading={get(current, "isLoading", false)}
      />
      {get(services, "isSuccess", true) &&
        <Stack sx={{ mt: 2 }} alignContacts="flex-end">
          <Pagination
            count={(Math.trunc((get(services, "totalRecords", 1) + PageSize) / PageSize))}
            page={get(services, "pageNumber", 1)}
            onChange={onChangePagination}
            color="secondary"
            sx={{ "& li > button": { borderRadius: 1 } }}
          />
        </Stack>
      }
      {get(importService, "isLoading", false) && (
        <Dialog open={get(importService, "isLoading")} maxWidth="sm" sx={{ '& .MuiDialog-paper': { width: '250px', maxWidth: '90%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 3 } }} >
          <Fade in={get(importService, "isLoading")}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 3 }}>
              <CircularProgress />
              <Typography variant="caption" sx={{ mt: 2, ml: 2 }}>
                {__("Cargando...")}
              </Typography>
            </Box>
          </Fade>
        </Dialog>
      )}
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'center' }}
        anchorOrigin={{ horizontal: 'left', vertical: 'center' }}
      >
        <MenuItem onClick={() => { setOpenModal(true); setAnchorEl(null) }}>{__(`table.menu.edit`)}</MenuItem>
        <MenuItem onClick={ () => {
            if (canView("MAESTROS/CLIENTES/TARIFARIOS", "delete")) {
              handleDelete(selected)()
            } else {
              setAlert({
                open: true,
                title: "Permiso Denegado.",
                subtitle: (<ul> • No tienes permiso para eliminar tarifarios.</ul>),
                type: "error",
                btn: __(`${module}.actions.close`),
                func: closeAlert
              })
            }
        }}>{__(`table.menu.delete`)}</MenuItem>
      </Menu>
      <Notification __={__} showNoti={showNoti} setShowNoti={setShowNoti} />
      <Alert
        title={get(alert, "title")}
        subtitle={get(alert, "subtitle")}
        btn1={{ func: get(alert, "func") }}
        btn2={{}}
        type={get(alert, "type")}
        openAlert={get(alert, "open")}
        closeAlert={closeAlert}
      />
      <TariffModal
        __={__}
        open={openModal}
        close={() => setOpenModal(false)}
        showNoti={showNoti}
        setShowNoti={setShowNoti}
        alert={alert}
        setAlert={setAlert}
        setError={setError}
        reload={reload}
        selected={selected}
        setSelected={setSelected}
        idClient={id}
      />
      <Question
        title={__("alert.deletetariff.title")}
        detail={__("alert.deletetariff.detail")}
        onSuccess={onDelete}
        onCancel={() => setOpenQuestion(false)}
        open={openQuestion}
        loading={get(delet, "isLoading")}
      />
    </div>
  )
}

export default Tarrif;
